
import { enmContentType } from "../models/enums/ContentType";
import { mdlBaseHotelIdRequest } from "../models/service-models/common/BaseHotelIdRequest";
import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlBaseRequest } from "../models/service-models/common/BaseRequest";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlFactSheetFileUploadRequest } from "../models/service-models/fact-sheet/FactSheetFileUploadRequest";
import { mdlFactSheetGetCategoriesRequest } from "../models/service-models/fact-sheet/FactSheetGetCategoriesRequest";
import { mdlFactSheetGetCategoriesResponse } from "../models/service-models/fact-sheet/FactSheetGetCategoriesResponse";
import { mdlFactSheetHMSResponse } from "../models/service-models/fact-sheet/FactSheetHMSResponse";
import { mdlFactSheetHotelAccountRequest } from "../models/service-models/fact-sheet/FactSheetHotelAccountRequest";
import { mdlFactSheetHotelAccountResponse } from "../models/service-models/fact-sheet/FactSheetHotelAccountResponse";
import { mdlFactSheetHotelAccountSaveRequest } from "../models/service-models/fact-sheet/FactSheetHotelAccountSaveRequest";
import { mdlFactSheetHotelAccountSaveResponse } from "../models/service-models/fact-sheet/FactSheetHotelAccountSaveResponse";
import { mdlFactSheetItemsRequest } from "../models/service-models/fact-sheet/FactSheetItemsRequest";
import { mdlFactSheetItemsResponse } from "../models/service-models/fact-sheet/FactSheetItemsResponse";
import { mdlFactSheetItemUpdateInsertRequest } from "../models/service-models/fact-sheet/FactSheetItemUpdateInsertRequest";
import { mdlFactSheetItemUpdateInsertResponse } from "../models/service-models/fact-sheet/FactSheetItemUpdateInsertResponse";
import { mdlFactSheetLanguageResponse } from "../models/service-models/fact-sheet/FactSheetLanguageResponse";
import { mdlFactSheetRoomItemResponse } from "../models/service-models/fact-sheet/FactSheetRoomItemResponse";
import { mdlFactSheetRoomItemSaveRequest } from "../models/service-models/fact-sheet/FactSheetRoomItemSaveRequest";
import { mdlFactSheetTemplateRequest } from "../models/service-models/fact-sheet/FactSheetTemplateRequest";
import { mdlFactSheetTemplateResponse } from "../models/service-models/fact-sheet/FactSheetTemplateResponse";
import { GetResponse } from "../utils/ApiClient";

module FactSheetService {
    export async function GetHotelAccount(
        pRequest: mdlFactSheetHotelAccountRequest
    ): Promise<mdlServiceResponse<mdlFactSheetHotelAccountResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetHotelAccountResponse>>(
            "factSheet/get-hotel-account",
            pRequest
        );
    }
    export async function GetCategories(
        pRequest: mdlFactSheetGetCategoriesRequest
    ): Promise<mdlServiceResponse<mdlFactSheetGetCategoriesResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetGetCategoriesResponse>>(
            "factSheet/get-categories",
            pRequest
        );
    }
    export async function GetItemsByCategoryId(
        pRequest: mdlFactSheetItemsRequest
    ): Promise<mdlServiceResponse<mdlFactSheetItemsResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetItemsResponse>>(
            "factSheet/get-items",
            pRequest
        );
    }
    export async function UpdateInsertItem(
        pRequest: mdlFactSheetItemUpdateInsertRequest
    ): Promise<mdlServiceResponse<mdlFactSheetItemUpdateInsertResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetItemUpdateInsertResponse>>(
            "factSheet/save-item",
            pRequest
        );
    }
    export async function HotelAccountSave(
        pRequest: mdlFactSheetHotelAccountSaveRequest
    ): Promise<mdlServiceResponse<mdlFactSheetHotelAccountSaveResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetHotelAccountSaveResponse>>(
            "factSheet/save-hotel-account",
            pRequest
        );
    }
    export async function GetTemplateData(
        pRequest: mdlFactSheetTemplateRequest
    ): Promise<mdlServiceResponse<mdlFactSheetTemplateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetTemplateResponse>>(
            "factSheet/get-template-parameters",
            pRequest
        );
    }
    export async function GetHMSList(
        pRequest: mdlBaseRequest
    ): Promise<mdlServiceResponse<mdlFactSheetHMSResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetHMSResponse>>(
            "factSheet/get-hms-list",
            pRequest
        );
    }
    export async function FileUpload(
        pRequest: FormData
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "factSheet/file-upload",
            pRequest,
            enmContentType.FormData
        );
    }
    export async function GetRoomItems(
        pRequest: mdlBaseHotelIdRequest
    ): Promise<mdlServiceResponse<mdlFactSheetRoomItemResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetRoomItemResponse>>(
            "factSheet/get-room-items",
            pRequest
        );
    }
    export async function SaveRoomItem(
        pRequest: mdlFactSheetRoomItemSaveRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "factSheet/save-room-item",
            pRequest
        );
    }
    export async function GetLanguages(
        pRequest: mdlBaseRequest
    ): Promise<mdlServiceResponse<mdlFactSheetLanguageResponse>> {
        return await GetResponse<mdlServiceResponse<mdlFactSheetLanguageResponse>>(
            "factSheet/get-language-list",
            pRequest
        );
    }
}
export { FactSheetService };
